module.exports = __webpack_public_path__ + "static/media/currency-fill.e8dfcabb.svg";